































































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator';

import CalendarLayout from './CalendarLayout.vue';
import CalendarView from './CalendarView.vue';
import CalendarServices from './CalendarServices.vue';
import CalendarAction from './CalendarAction.vue';

import FormScheduleSet from './forms/schedule/FormScheduleSet.vue';
import FormScheduleEdit from './forms/schedule/FormScheduleEdit.vue';

import FormVacationEdit from './forms/FormVacationEdit.vue'
import SlotForm from './forms/SlotForm.vue';
import ConfirmModal from '@/components/modal/ConfirmModal.vue';
import NotifyModal from '@/components/modal/NotifyModal.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import IconRemove from '@/components/icons/Remove.vue';
import IconEdit from '@/components/icons/Edit.vue';

import {CalendarType, SlotsClinicMap, SlotsCustomMap, SlotType} from '@/components/calendar/types';
import { SelectItem } from '@/components/select/types';
import { Slot, VacationSlot } from './types';

import { getTodayDate, addMinutes } from '@/utils/date';

import { ISOCalendarDate, ISODateRange, ISODateTimeRange } from '@/utils/date/types';
import { ScheduleSetForm, ScheduleEditForm } from './forms/schedule/types';
import { SlotsMap } from './types';
import { Maybe } from '@/types/common';
import {BackendSlotCustom} from "@/api/calendar/backend";

enum Modal {
    None = '',
    RemoveConfirm = 'removeConfirm',
    RemoveNotify = 'removeNotify'
}

type SidebarState = '' | 'schedule-set' | 'schedule-edit' | 'vacation-edit';

interface SchedulePayload {
    date: ISOCalendarDate,
    clinics: SelectItem[],
    custom?: BackendSlotCustom,
}

interface VacationPayload {
    vacation: VacationSlot,
}

interface SidebarForm {
    state: SidebarState,
    payload: SchedulePayload | VacationPayload | null,
}

const NO_SIDEBAR: SidebarForm = {
    state: '',
    payload: null,
}

@Component({
    components: {
        CalendarLayout,
        CalendarView,
        CalendarServices,
        CalendarAction,
        FormScheduleSet,
        FormScheduleEdit,
        FormVacationEdit,
        SlotForm,
        ConfirmModal,
        NotifyModal,
        BaseButton,
        IconRemove,
        IconEdit,
    },
})
export default class CalendarAdmin extends Vue {
    @Prop({ default: () => ({}) }) slots!: SlotsMap
    @Prop({ default: () => ({}) }) slotsClinic!: SlotsClinicMap
    @Prop({ default: () => ({}) }) slotsCustom!: SlotsCustomMap
    @Prop({ required: true }) clinics!: SelectItem[]
    @Prop({ default: false }) hasCommonPractice!: boolean;
    @Ref() readonly calendar!: CalendarView;

    date = getTodayDate();
    sidebar = NO_SIDEBAR

    selectedEvent: Maybe<Slot> = null;
    selectedSlotRange: Maybe<ISODateTimeRange> = null;
    modalState = Modal.None

    dateToRemove: ISOCalendarDate | '' = ''

    get isEditingSchedule() {
        return this.sidebar.state === 'schedule-edit';
    }

    get isSettingSchedule() {
        return this.sidebar.state === 'schedule-set';
    }

    get isEditingVacation() {
        return this.sidebar.state === 'vacation-edit';
    }

    get Modal() {
        return Modal;
    }

    get clinic() {
        const clinics = this.slotsClinic[this.date];

        if (Array.isArray(clinics) && clinics.length > 0) {
            return clinics[0];
        }

        return null;
    }

    loadSlots(range: ISODateRange) {
        this.$emit('slots:load', range)
    }

    selectEvent(slot: Slot) {
        this.selectedEvent = slot;

        this.closeSidebar();
        this.highlightSelectedSlot(slot);
    }

    highlightSelectedSlot(slot: Slot) {
        if (slot.type === SlotType.Free) {
            this.selectedSlotRange = {
                start: slot.start,
                end: slot.end,
            };

            return;
        }

        this.selectedSlotRange = null;
    }

    updateDuration(duration: number) {
        if (!this.selectedSlotRange) {
            return;
        }
        
        const { start } = this.selectedSlotRange;
        const end = addMinutes(start, duration);

        this.selectedSlotRange = {
            start,
            end,
        };
    }

    isMonthView(type: CalendarType) {
        return type === CalendarType.Month;
    }

    goPreviousPage() {
        this.calendar.goPreviousPage();
    }

    goNextPage() {
        this.calendar.goNextPage();
    }

    createConsultation(consultation: any) {
        this.$emit('create:consultation', consultation);
        this.closeConsultation();
    }

    removeConsultation() {
        console.log('remove', this.selectedEvent);
    }

    closeConsultation() {
        this.selectedEvent = null;
        this.selectedSlotRange = null;
    }

    // schedule

    setSchedule() {
        this.closeConsultation();
        this.sidebar = {
            state: 'schedule-set',
            payload: {
                date: this.date,
                clinics: this.clinics,
            },
        };
    }

    editSchedule(date: ISOCalendarDate) {
        this.closeConsultation();

        this.sidebar = {
            state: 'schedule-edit',
            payload: {
                date,
                clinics: this.clinics,
                custom: this.slotsCustom[date],
            },
        };
    }

    closeSidebar() {
        this.sidebar = NO_SIDEBAR;
    }

    removeSchedule() {
        this.$emit('remove:schedule', this.dateToRemove);
        this.closeModal();
    }

    updateTemplateSchedule(schedule: ScheduleSetForm) {
        this.$emit('set:clinic-schedule', schedule);
    }

    updateDateSchedule(schedule: ScheduleEditForm) {
        this.$emit('edit:clinic-schedule', schedule);
    }

    // vacation

    selectVacation(vacationSlot: VacationSlot) {
        this.sidebar = {
            state: 'vacation-edit',
            payload: {
                vacation: vacationSlot,
            },
        };
    }

    createVacation(dates: ISODateRange) {
        this.$emit('create:vacation', dates)
    }
    
    updateVacation(vacation: { vacation: VacationSlot; dates: ISODateRange }) {
        this.$emit('update:vacation', vacation)

        this.closeSidebar();
    }

    removeVacation(vacation: VacationSlot) {
        this.$emit('remove:vacation', vacation)
    }

    askForRemoveConfirmation(date: ISOCalendarDate) {
        const daySlots = this.slots[date] ?? [];

        const hasReservedSlot = daySlots.some(slot => {
            return slot.type === SlotType.Reserved;
        })

        if (hasReservedSlot) {
            this.modalState = Modal.RemoveNotify;
            return;
        }

        this.dateToRemove = date;
        this.modalState = Modal.RemoveConfirm;
    }
    
    // modals

    isModalOpen(modal: Modal) {
        return this.modalState === modal
    }

    closeModal() {
        this.dateToRemove = '';
        this.modalState = Modal.None
    }
}
